import { ICONS } from '@/Icons.tsx';
import React, { FC } from 'react';
import { useSelfieCanvasIos } from '@/components/slides/Selfie/iOS/useSelfieCanvasIos.ts';
import { CustomOverlayNavigation } from '@/components/slides/Selfie/CustomOverlayNavigation.tsx';
import { useNavigation } from '@/navigation/NavigationContex';
import { translate } from '@/translation/translate';

interface SelfieOverlayProps {
  onClose: () => void;
}

export const SelfieOverlayIos: FC<SelfieOverlayProps> = ({ onClose }) => {
  const { currentSlide } = useNavigation();

  const {
    canvasRef,
    parentRef,
    nextFrame,
    prevFrame,
    prevFrameSrc,
    nextFrameSrc,
    takeSnapshot,
    clearSnapshot,
    shareSnapshot,
    hasSnapshot,
    width,
    height,
    shareButtonWasClicked,
  } = useSelfieCanvasIos();

  const showControlButtons = width > 0 && height > 0;

  return (
    <div className={'overlay'} ref={parentRef}>
      <div className={'close-bar'}>
        <button data-cy={'close-overlay'} className="close" onClick={onClose}>
          <i className={ICONS.cancel} />
        </button>
      </div>

      <div className={'selfie-wrapper'}>
        <div
          className={'video-container'}
          style={{
            width: width,
            height: height,
          }}
        >
          <div className={'video-cropper'} style={{ width: width, height: height }}>
            <i className={ICONS.selfie} />
          </div>

          <canvas width={width} height={height} ref={canvasRef} id={'selfie-canvas'} />
        </div>

        {showControlButtons && (
          <div
            className={'control-center'}
            style={{
              width: width,
              height: height,
            }}
          >
            <div className={'prev-frame'}>
              <button onClick={prevFrame}>
                <img src={prevFrameSrc} alt="Previous Filter" />
              </button>
            </div>
            {hasSnapshot && (
              <div className={'clear-snapshot'}>
                <button onClick={clearSnapshot}>
                  <i className={ICONS.cancel} />
                </button>
              </div>
            )}
            <div className={'share-snapshot'}>
              {hasSnapshot && (
                <button onClick={shareSnapshot}>
                  <i className={ICONS.shareSelfie} />
                </button>
              )}
            </div>
            <div className={'take-snapshot'}>
              {!hasSnapshot && (
                <>
                  <input
                    type="file"
                    id={'take-snapshot-input'}
                    accept="image/*"
                    capture={'user'}
                    onChange={takeSnapshot}
                  />
                  <label htmlFor="take-snapshot-input">
                    <i className={ICONS.takeSelfie} />
                  </label>
                </>
              )}
            </div>
            <div className={'next-frame'}>
              <button onClick={nextFrame}>
                <img src={nextFrameSrc} alt="Next Filter" />
              </button>
            </div>
            {currentSlide?.selfiehandle && <div className={'social-handle'}>{currentSlide?.selfiehandle}</div>}
            {currentSlide?.selfietag && <div className={'social-tag'}>{currentSlide?.selfietag}</div>}
            {currentSlide?.selfieinfotext && (
              <div className={'info-text'}>{translate(currentSlide?.selfieinfotext)}</div>
            )}
          </div>
        )}
      </div>

      <CustomOverlayNavigation shareButtonWasClicked={shareButtonWasClicked} />
    </div>
  );
};
